<form id="stepForm" [formGroup]="pageForm" *ngIf="pageForm" class="form-grid-new terra-error-style">
  <div class="half-width">
    <h3 class="section-title">
      Contact information
    </h3>
    <!--  Email address -->
    <div class="terra-form-field-wrapper">
      <label for="txtEmail" class="text-input-label">
        Contact email address-<br/>
        Will be presented in the Investor Portal to allow investors to contact you directly via email correspondence
      </label>
      <mat-form-field appearance="outline">
        <input matInput id="txtEmail" formControlName="email" class="lo_sensitive"/>
        <mat-error *ngIf="pageForm.get('email').hasError('email')">
          Please enter a valid email address
        </mat-error>
        <mat-error *ngIf="pageForm.get('email').hasError('required')">
          Email is required
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="half-width">
    <h3 class="section-title">
      Investor portal
    </h3>
    <div class="terra-form-field-wrapper toggle-item font-semibold">
      <span>Show in Investor Portal
        <mat-icon class="notranslate terra-tooltip" matTooltipClass="terra-tooltip" #tooltip="matTooltip"
                  matTooltip="{{investorPortalTooltip}}">
          help
        </mat-icon>
      </span>
      <mat-slide-toggle hideIcon labelPosition="before" (change)="makeSurePrivateStateAllowed($event)" [checked]="!pageForm.get('isPrivate')?.value" />
    </div>
    <div class="terra-form-field-wrapper toggle-item">
      <span>Investors May Set Bank Account</span>
      <mat-slide-toggle hideIcon labelPosition="before" formControlName="allowLpSetBank" />
    </div>
    <div class="terra-form-field-wrapper toggle-item">
      <span>Display IRR</span>
      <mat-slide-toggle hideIcon labelPosition="before" formControlName="displayIrr" />
    </div>
    <div class="terra-form-field-wrapper toggle-item">
      <span>Display Cash on Cash</span>
      <mat-slide-toggle hideIcon labelPosition="before" formControlName="displayCashOnCash" />
    </div>
    <div class="terra-form-field-wrapper toggle-item">
      <span>Display Equity Multiple</span>
      <mat-slide-toggle hideIcon labelPosition="before" formControlName="displayEquityMultiple" />
    </div>
    <div class="terra-form-field-wrapper toggle-item">
      <span>Display Ownership Percentage</span>
      <mat-slide-toggle hideIcon labelPosition="before" formControlName="lpOwnershipVisibility" />
    </div>
    <div class="terra-form-field-wrapper toggle-item">
      <span>Display Commitment Amounts</span>
      <mat-slide-toggle hideIcon labelPosition="before" formControlName="displayCommitments" />
    </div>
    <div class="terra-form-field-wrapper toggle-item">
      <span>Display Net Asset Value
        <mat-icon class="notranslate terra-tooltip" matTooltipClass="terra-tooltip" matTooltip="{{navTooltipText}}"> help </mat-icon>
      </span>
      <mat-slide-toggle hideIcon labelPosition="before" formControlName="displayNetAssetValue" (change)="makeSureNavIsAllowed($event, 'displayNetAssetValue')" />
    </div>
    <div class="terra-form-field-wrapper toggle-item">
      <span>Include Unrealized NAV
        <mat-icon class="notranslate terra-tooltip" matTooltipClass="terra-tooltip" matTooltip="{{IncludeUnrealizedNavTooltipText}}"> help </mat-icon>
      </span>
      <mat-slide-toggle hideIcon labelPosition="before" formControlName="includeUnrealizedNav" (change)="makeSureNavIsAllowed($event, 'includeUnrealizedNav')" />
    </div>
    <div class="terra-form-field-wrapper toggle-item">
      <span>Display Shares
        <mat-icon class="notranslate terra-tooltip" matTooltipClass="terra-tooltip" matTooltip="{{sharesTooltipText}}"> help </mat-icon>
      </span>
      <mat-slide-toggle hideIcon labelPosition="before" formControlName="displayShares" />
    </div>
  </div>

  <div class="half-width">
  <!-- Payment request supporting documents -->
  <h3 class="section-title" id="editHoldingPaymentRequestDocument">
    Upload Cross-Border Transaction Reason (Optional)
  </h3>
  <p class="supporting-documents-hint full-width">
    For cross-border payment compliance, a transaction reason must be provided, e.g. a Purchase or Loan Agreement. You can
    attach documents here that apply to all investors. These will be included with every transaction in this deal.
  </p>

  <ng-container formArrayName="assetPaymentRequestDocuments">
    <div class="half-width">
      <terra-file-uploader class="file-uploader" no-type-select formControlName="0" [isSubmitted]="isSubmitAttempt" [required]="false" />
      <terra-file-uploader class="file-uploader" no-type-select formControlName="1" [isSubmitted]="isSubmitAttempt" [required]="false" />
      <terra-file-uploader class="file-uploader" no-type-select formControlName="2" [isSubmitted]="isSubmitAttempt" [required]="false" />
      <terra-file-uploader class="file-uploader" no-type-select formControlName="3" [isSubmitted]="isSubmitAttempt" [required]="false" />
    </div>

    <a class="add-more-photos-link full-width" (click)="showSecondDocumentsRow = true" *ngIf="!showSecondDocumentsRow">
      <mat-icon class="notranslate" color="primary">add_circle</mat-icon>
      Add more documents
    </a>

    <div class="half-width" *ngIf="showSecondDocumentsRow">
      <terra-file-uploader class="file-uploader" no-type-select formControlName="4" [isSubmitted]="isSubmitAttempt"
                           [required]="false">
      </terra-file-uploader>
      <terra-file-uploader class="file-uploader" no-type-select formControlName="5" [isSubmitted]="isSubmitAttempt"
                           [required]="false">
      </terra-file-uploader>
      <terra-file-uploader class="file-uploader" no-type-select formControlName="6" [isSubmitted]="isSubmitAttempt"
                           [required]="false">
      </terra-file-uploader>
      <terra-file-uploader class="file-uploader" no-type-select formControlName="7" [isSubmitted]="isSubmitAttempt"
                           [required]="false">
      </terra-file-uploader>
    </div>
    <p class="error-message full-width" *ngIf="pageForm.get('assetPaymentRequestDocuments').invalid">The files marked in
      red are of an
      unsupported file
      type.
    </p>
    <p class="file-uploader-hint new-column">
      File format must be JPG, JPEG, PNG (20 MB max file size) or PDF (50 MB max file size)
    </p>
  </ng-container>
</div>

</form>
